import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25c4713f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "register",
  class: "flex"
}
const _hoisted_2 = {
  key: 0,
  class: "flex"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Please wait...", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "password-disclaimer" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "small" }, [
    /*#__PURE__*/_createTextVNode("Login using your "),
    /*#__PURE__*/_createElementVNode("span", null, "Patreon"),
    /*#__PURE__*/_createTextVNode(" email (for linking)")
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "submit" }, "Authenticate", -1))
const _hoisted_8 = {
  key: 2,
  id: "finish",
  class: "flex content-width"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" An email has been sent. "),
  /*#__PURE__*/_createElementVNode("strong", null, "It may show up in your spam folder"),
  /*#__PURE__*/_createTextVNode(", so you'll need to move it to inbox before the link shows. I'm currently in the process of fixing this :) ")
], -1))

import { inject, ref } from "vue";
import { sendSignInLinkToEmail } from "firebase/auth";
import { auth } from "@/assets/ts/firebase";
import { SHOW_TOAST } from "@/assets/ts/Constants";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

var mitt = inject("emitter") as any;

var router = useRouter();

var user = ref<UserPass>({ email: "", password: "" } as UserPass);
var loading = ref(false);
var finished = ref(false);
const register = async () => {
  const actionCodeSettings = {
    url: process.env.VUE_APP_CALLBACK,
    handleCodeInApp: true,
  };

  try {
    if (auth.currentUser != null && auth.currentUser.email == user.value.email) {
      return router.push("/");
    }

    loading.value = true;
    await sendSignInLinkToEmail(auth, user.value.email, actionCodeSettings);
    window.localStorage.setItem("emailForSignIn", user.value.email);
    // mitt.emit(SHOW_TOAST, {
    //   title: "An email has been sent!",
    //   msg: "If you don't recieve the email, check your spam folder and move it to your inbox to recover the link",
    //   type: "success",
    // } as toastConfig);
    finished.value = true;
  } catch (error) {
    mitt.emit(SHOW_TOAST, { title: "Woops", msg: error, type: "error" } as toastConfig);
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(loading) && !_unref(finished))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (!_unref(loading) && !_unref(finished))
        ? (_openBlock(), _createElementBlock("form", {
            key: 1,
            onSubmit: _withModifiers(register, ["prevent"]),
            class: "flex"
          }, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              type: "email",
              placeholder: "Your Patreon email address...",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(user).email) = $event))
            }, null, 512), [
              [_vModelText, _unref(user).email]
            ]),
            _hoisted_7
          ], 40, _hoisted_5))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("button", {
              class: "blue",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(finished) //@ts-ignore
 ? finished.value = false : finished = false))
            }, "Use a different email?")
          ]))
  ]))
}
}

})